//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MiniNavBar from '@/components/MiniNavBar.vue';
export default {
    components: { MiniNavBar },
    beforeRouteEnter(to, from, next) {
        const obj = {
            wharfCulture: 0,
            redCulture: 1,
            folkCulture: 2
        };
        const params = to.params;
        next(vm => {
            vm.getTypes();
            vm.getRed();
            vm.getWharf();
            vm.getCustom();
            vm.currentItem = obj[params.anchor] || 0;
        });
    },
    data() {
        return {
            currentItem: 0,
            typeList: [],
            red: '',
            wharf: '',
            custom: '',
            banner: ''
        };
    },
    computed: {
        transX() {
            return this.currentItem * -100 + '%';
        }
    },
    methods: {
        getTypes() {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 6
                }
            }).then(res => {
                if (res.code === 0) {
                    this.typeList = res.data;
                }
            });
        },
        getRed() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '43'
                }
            }).then(res => {
                if (res.code === 0) {
                    this.red = res.data.content;
                }
            });
        },
        getCustom() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '44'
                }
            }).then(res => {
                if (res.code === 0) {
                    this.custom = res.data.content;
                }
            });
        },
        getWharf() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '42'
                }
            }).then(res => {
                if (res.code === 0) {
                    this.wharf = res.data.content;
                }
            });
        }
    }
};
